import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { api } from "@/lib/api";
import { API_ORIGIN } from "@/admin/ui";

export const PublicVideo = ({ slug, testid }) => {
  const [video, setVideo] = useState(null);
  useEffect(() => {
    api.get(`/resources/${slug}`).then((r) => setVideo(r.data.slots?.video?.[0] || null)).catch(() => {});
  }, [slug]);
  return video ? (
    <video className="media-video" src={`${API_ORIGIN}${video.url}`} controls preload="metadata" data-testid={`${testid}-player`} />
  ) : (
    <div className="media-video media-ph" data-testid={`${testid}-placeholder`}>
      <span className="audio-play" aria-hidden="true"><Play /></span>
      <small>Vídeo disponible pronto</small>
    </div>
  );
};
